import { ComponentProps } from "react"
import { formatISO, setHours, setMinutes } from "date-fns"
import { Banner } from "@/components/ui/banner"
import { CriticalityLevel, DisplayFor, UserRoleValues } from "@/types/__generated__/union-types"

export const removeTimeFromDate = (inputDate: Date): Date => {
  // Set hours, minutes, seconds, and milliseconds to zero
  const newDate = new Date(inputDate)
  newDate.setHours(0, 0, 0, 0)
  return newDate
}

export const combineDateAndTime = (dateStr: Date, timeStr: string): string => {
  const [hours, minutes] = timeStr.split(":").map(Number)
  const dateWithHours = setHours(dateStr, hours)
  const combinedDate = setMinutes(dateWithHours, minutes)

  return formatISO(combinedDate)
}

export const displayForData = UserRoleValues.filter(
  (
    role,
  ): role is Exclude<
    (typeof UserRoleValues)[number],
    | "MEDICAL_SUPERVISOR"
    | "NONE"
    | "SOFIA_ADMIN"
    | "SOFIA_ADMIN_TECHNICAL_ADMIN"
    | "SOFIA_ADMIN_BUSINESS_ADMIN"
    | "SOFIA_ADMIN_BUSINESS_EDITOR"
    | "SOFIA_ADMIN_MEDICAL_ADMIN"
    | "SOFIA_ADMIN_AI_ADMIN"
  > =>
    role !== "MEDICAL_SUPERVISOR" &&
    role !== "NONE" &&
    role !== "SOFIA_ADMIN" &&
    role !== "SOFIA_ADMIN_TECHNICAL_ADMIN" &&
    role !== "SOFIA_ADMIN_BUSINESS_ADMIN" &&
    role !== "SOFIA_ADMIN_BUSINESS_EDITOR" &&
    role !== "SOFIA_ADMIN_MEDICAL_ADMIN" &&
    role !== "SOFIA_ADMIN_AI_ADMIN",
).map((role) => ({
  label: `common.roles.${role}`,
  value: role,
}))

export const getVariantNews = (criticalityLevel: CriticalityLevel) => {
  const variantMap: Record<CriticalityLevel, ComponentProps<typeof Banner>["variant"]> = {
    CRITICAL: "critical",
    WARNING: "warning",
    INFO: "info",
  }

  return variantMap[criticalityLevel]
}

export const getDisplayForByRole = (role: string): DisplayFor => {
  let displayFor: DisplayFor
  switch (role) {
    case "CallCenterAgent":
      displayFor = "CALL_CENTER_AGENT"
      break
    case "CustomerServiceCenter":
      displayFor = "CUSTOMER_SERVICE_CENTER"
      break
    case "NursingProfessional":
      displayFor = "NURSING_PROFESSIONAL"
      break
    case "Doctor":
      displayFor = "DOCTOR"
      break
    default:
      displayFor = "NONE"
      break
  }

  return displayFor
}
